import { IntegrationConnectionResource } from "@arrowsup/platform-dtos";
import { useContext, useMemo } from "react";
import { ApiContext } from "../api/api-context";

/** Checks a connection's key still works, recording the result. */
export const useVerifyIntegrationConnection = () => {
  const api = useContext(ApiContext).api;
  return useMemo(
    () => async (id: number) =>
      (
        await api.post<IntegrationConnectionResource>(
          `/api/integration-connections/${id}/verify`
        )
      ).data,
    [api]
  );
};
